import React, { useCallback, useContext, useEffect, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../App";
import commonLib from "../control/commonLib";
import {selfCheckingCheckedIn,selfCheckInId} from "../control/Constant";
import konsole from "../network/konsole";
import Services from "../network/Services";
import Toaster from "../Toaster/Toaster";

const QrCode = () => {
  const [qrCode, setQRCode] = useState({
    uId: "",
    stage: "",
  });

  const { setLoader } = useContext(UserContext);
  const navigate = useNavigate();

  const handleWalkInCheckInUser = useCallback(
    (seminarId, seminarAttendeeId, attendeeUserId, semUserStatusId, upsertedBy) => {
      setLoader(true);

      Services.updateSeminarAttendeeInfo(
        seminarId,
        seminarAttendeeId,
        attendeeUserId,
        semUserStatusId,
        upsertedBy
      )
        .then((res) => {
          konsole.log("registered Checkin res", res);

          commonLib.setDatatoSession(
            "GetResponse",
            JSON.stringify(res.data.data)
          );

          const selfWalkInCheckInObj = res.data.data.attendees[0];
          const bookedSeats = {
            sheets: selfWalkInCheckInObj.allottedSeats,
          };

          navigate("/Congratulations", { state: bookedSeats });
        })
        .catch((err) => {
          konsole.log("errs", err.response);
          Toaster.error(
            err.response?.data?.messages?.[0] || "Check-in failed."
          );
        })
        .finally(() => {
          setLoader(false);
        });
    },
    [navigate, setLoader]
  );

  const validateSeminarAttendee = useCallback(
    (subtenantId, seminarId, contact, status) => {
      setLoader(true);

      Services.validateSeminarAttendee(
        subtenantId,
        seminarId,
        contact,
        status
      )
        .then((res) => {
          const validateUserResponse = res.data.data[0];

          handleWalkInCheckInUser(
            seminarId,
            validateUserResponse.seminarAttendeeId,
            validateUserResponse.seminarAttendeeUserId,
            selfCheckInId,
            validateUserResponse.seminarAttendeeUserId
          );
        })
        .catch((err) => {
          konsole.log("errd", err.response);
          Toaster.error(
            err.response?.data?.messages?.[0] || "Attendee validation failed."
          );
        })
        .finally(() => {
          setLoader(false);
        });
    },
    [handleWalkInCheckInUser, setLoader]
  );

  const saveInStorage = useCallback(
    (accessObj, stage) => {
      konsole.log("ssf", accessObj);

      const seminarObj = commonLib.getSeminarObj(accessObj);
      const attendeeObj = commonLib.getSeminarAttendee(accessObj);

      Services.getDeviceType(() => {
        commonLib.setSessionStoarge(
          "attendeeObj",
          JSON.stringify(attendeeObj)
        );

        const subtenantId = seminarObj.seminarSubtenantId;
        const seminarId = seminarObj.seminarId;
        const attendeeEmailAddress = attendeeObj?.attendeeEmailAddress;

        if (stage === "CHECKIN") {
          validateSeminarAttendee(
            subtenantId,
            seminarId,
            attendeeEmailAddress,
            selfCheckingCheckedIn
          );
        }
      });
    },
    [validateSeminarAttendee]
  );

  const getSeminarAttendeeAccessLink = useCallback(
    (uniqueKey, stage) => {
      setLoader(true);

      Services.getSeminarAttendeeAccessLink(uniqueKey)
        .then((res) => {
          const accessObj = res.data.data;

          commonLib.setSessionStoarge(
            "venueObj2",
            JSON.stringify(accessObj)
          );

          saveInStorage(accessObj, stage);
        })
        .catch((err) => {
          konsole.log("err", err.response);
          Toaster.error(
            err.response?.data?.messages?.[0] || "Unable to read QR code."
          );
        })
        .finally(() => {
          setLoader(false);
        });
    },
    [saveInStorage, setLoader]
  );

  useEffect(() => {
    if (qrCode.uId && qrCode.stage) {
      getSeminarAttendeeAccessLink(qrCode.uId, qrCode.stage);
    }
  }, [qrCode.uId, qrCode.stage, getSeminarAttendeeAccessLink]);

  useEffect(() => {
    const scanner = new Html5QrcodeScanner(
      "qr-reader",
      {
        fps: 10,
        qrbox: { width: 250, height: 250 },
      },
      false
    );

    let alreadyScanned = false;

    scanner.render(
      (decodedText) => {
        if (alreadyScanned) return;

        const uId = commonLib.GetQueryValues(decodedText, "UID");
        const stage = commonLib.GetQueryValues(decodedText, "Stage");

        if (uId && stage) {
          alreadyScanned = true;
          setQRCode({ uId, stage });
          scanner.clear().catch((err) => {
            konsole.log("Scanner cleanup error", err);
          });
        } else {
          Toaster.error("QR code does not contain UID and Stage.");
        }
      },
      (errorMessage) => {
        // Scanner continuously reports decode failures while searching.
      }
    );

    return () => {
      scanner.clear().catch(() => {});
    };
  }, []);

  return (
    <>
      <h3 className="text-center">
        Show your QR Code to Check-In.
      </h3>

      <div className="qrcodeConatiner">
        <div id="qr-reader" style={{ width: "100%" }} />
      </div>
    </>
  );
};

export default QrCode;
